var render = function render(){var _vm=this,_c=_vm._self._c;return _c('awesome-table',{attrs:{"labels":_vm.labels,"items":_vm.history,"options":{
        sort: false,
        addButton: false,
        pagination: false,
        searchInput: false,
        filters: false,
        link: false,
        clickableRows: false,
        isCard: false
    }}})
}
var staticRenderFns = []

export { render, staticRenderFns }